skrilla.directive('pickemsUserEntries', function () {
  return {
    templateUrl: 'directives/pickems/userEntries/userEntries.html',
    scope: {
      userId: "="
    },
    controller: function ($scope, searchService, queryService, paginationService, cacheService, dollarOrSkrillaFilter, modalService) {
      $scope.pageKey = "pickemsUserEntries";
      $scope.queryKey = "queryPickemsUserEntries";
      $scope.reset = function () {
        $scope.query = {
          limit: 20,

          statuses: {
            WON: true,
            PLACED: true,
            LIVE: true,
            LOST: true,
            CANCELLED: true
          },
          userId: $scope.userId
        };
      };

      function monetize(value) {
        return dollarOrSkrillaFilter(value, 'USD')
      }

      $scope.query = cacheService.getObject($scope.queryKey);

      if (!$scope.query) {
        $scope.reset()
      }

      const getEntries = function () {
        return searchService.get('pickems/contests/entries/' + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
          $scope.pickemsUserEntries = response.data.result;
          $scope.pickemsUserEntries.forEach((entry) => {
            entry.potentialPayout = monetize(entry.paidOut)
            if (entry.status === 'WON' || entry.status === "PLACED") {
              entry.payout = monetize(entry.paidOut)
            } else {
              entry.payout = monetize(0)
            }
          })
          paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
        });
      };

      $scope.search = function () {
        paginationService.resetPage($scope.pageKey);
        paginationService.pageQuery(getEntries, $scope.pageKey);
      };

      $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
          $scope.search();
      }

      $scope.showEntry = function(entry){
        searchService.get('pickems/contests/' + entry.contestId).then(function (response) {
          $scope.contest = response.data;
          cacheService.registerObject("entry", entry);
          cacheService.registerObject("contest", $scope.contest);
          modalService.openModal('/views/pickems/contestDetails/entryModal.html', true, 'lg', true, false);


        });
      }

    }
  };
});
